"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translationsNamespace = exports.defaultTranslations = void 0;
/* istanbul ignore file @preserve */
/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */

const defaultTranslations = exports.defaultTranslations = {
  addToListDialogMessage: 'Organise your favourite products into lists',
  addToListDialogTitle: 'Manage favourite lists',
  anonymousDialogMessage: 'Save your favourite products and create lists to share with others',
  anonymousDialogTitle: 'Login to create favourite lists',
  cancel: 'Cancel',
  createDescription: 'Create personalised lists of your favourite products and share them effortlessly.',
  createFailed: 'Failed to create list',
  createNewList: 'Create a new list',
  createSuccess: 'List created',
  delete: 'Delete',
  deleteDescription: 'Are you sure you want to delete “{listName}”?',
  deleteFailed: 'Failed to delete list',
  deleteList: 'Delete list',
  deleteSuccess: 'List deleted',
  description: 'Description',
  descriptionMaxLength: 'Description must have {maxLength} characters or less.',
  descriptionPlaceholder: 'Add the description of your list (max {maxLength} characters)',
  editDescription: 'Update your list name and description below',
  editFailed: 'Failed to update list',
  editList: 'Edit list',
  editSuccess: 'List updated',
  listName: 'List name',
  listNameMaxLength: 'List name must have {maxLength} characters or less.',
  listNameRequired: 'List name is required.',
  listsWereUpdated: 'Your list/s were updated',
  logIn: 'Log in',
  myFavourites: 'My favourites',
  productWasAddedToTheLists: 'Your list/s were updated',
  productWasRemovedFromTheLists: 'Your list/s were updated',
  productsLimitReached: "The list you've selected is full. Please choose another list or create a new one.",
  register: 'Register',
  save: 'Save',
  saveFailed: 'Failed to update list/s',
  saveList: 'Save list'
};
const translationsNamespace = exports.translationsNamespace = 'favorites-heart';
//# sourceMappingURL=defaultTranslations.js.map